import { defineMessages } from 'utils/intl';

export default defineMessages({
  notForSale: 'Produkt dostępny wyłącznie w zestawie',
  eol: 'Tego produktu nie ma już w sprzedaży',
});
